import { useState, type FormEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '@/lib/supabase'
import { Button, ErrorNote } from '@/components/ui'
import { AuthLayout } from '@/components/AuthLayout'

/** Used both by an invited facilitator on first login and by a password reset. */
export function SetPassword() {
  const navigate = useNavigate()
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function submit(event: FormEvent) {
    event.preventDefault()
    if (password !== confirm) {
      setError('The two passwords do not match.')
      return
    }
    if (password.length < 12) {
      setError('Use at least 12 characters. A short phrase you can remember beats a short jumble.')
      return
    }
    setBusy(true)
    const { error } = await supabase.auth.updateUser({ password })
    setBusy(false)
    if (error) setError(error.message)
    else navigate('/', { replace: true })
  }

  return (
    <AuthLayout>
      <h1 className="font-display text-2xl text-pounamu">Set your password</h1>
      <p className="mt-2 text-sm text-inksoft">
        This is your own login. Do not share it with others in your organisation, even
        temporarily: your organisation admin can add each facilitator their own.
      </p>
      <form onSubmit={submit} className="mt-5 rounded-lg border border-line bg-surface p-5">
        <label className="block text-sm font-medium text-ink" htmlFor="new-password">New password</label>
        <input
          id="new-password"
          type="password"
          autoComplete="new-password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mt-1 w-full rounded-sm border border-line px-3 py-2 text-sm"
        />
        <label className="mt-4 block text-sm font-medium text-ink" htmlFor="confirm-password">
          Type it again
        </label>
        <input
          id="confirm-password"
          type="password"
          autoComplete="new-password"
          required
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          className="mt-1 w-full rounded-sm border border-line px-3 py-2 text-sm"
        />
        {error && <div className="mt-4"><ErrorNote>{error}</ErrorNote></div>}
        <Button type="submit" className="mt-5 w-full" disabled={busy}>
          {busy ? 'Saving…' : 'Save password'}
        </Button>
      </form>
    </AuthLayout>
  )
}
